<template>
  <div>
    <IconCountList :chartData="chartData" />
  </div>
</template>

<script>
import IconCountList from "@/components/Mycharts/IconCountList.vue";

export default {
  name: "YetaiZiyuanFenxi",
  components: {
    IconCountList
  },
  props: {
    chartData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="less"></style>
